import React from 'react';
import { useState } from 'react';
import { BtnPrimary } from '../../../share/buttons/Btn';
import Card from '../../../share/cards/Card';
import { Modal } from '../../../share/modal/Modal';
import TableSort from '../../../share/Table/TableSort/TableSort';
import useFetch from '../../../../Hooks/useFetch';

// Assets
import { ReactComponent as Trash } from '../../../../Assets/Image/svg/trash.svg';
import { ReactComponent as Edit } from '../../../../Assets/Image/svg/edit.svg';
import { ReactComponent as Send } from '../../../../Assets/Image/svg/send.svg';

const DocumentsInfo = ({
	documentList,
	handleModalVisible,
	refreshList,
	handleSelectedDocument,
}) => {
	const { items, requestSort, sortConfig } = TableSort(documentList);

	const [documentId, setDocumentId] = useState(undefined);

	const deleteDocument = useFetch({
		method: 'DELETE',
		url: `CertificateService/${documentId}`,
		noHeader: false,
		trigger: false,
		caller: refreshList,
	});
	const handleDeleteDocument = (id) => {
		setDocumentId(id);
		deleteDocument.reFetch();
	};

	return (
		<div className='px-10'>
			<div className=' flex SupportTicket__header justify-between items-center mt-[5rem]'>
				<h3 className=' text-[#77498F] text-[1.6rem] font-bold'>
					اطلاعات مدارک بوت کمپ
				</h3>
				<BtnPrimary
					text='مدرک جدید '
					className='px-16 py-7'
					onClick={() => handleModalVisible()}
				/>
			</div>

			<>
				<Card className=' grid grid-cols-5 px-[3rem] py-[1.5rem] gap-[4rem] justify-items-center justify-between items-center text-[1.6rem] h-[8rem] SupportTicketTable-header mt-[1rem]'>
					{header.map((item, id) =>
						id === 0 ? (
							<div
								key={item.title}
								className='text-[#212121E5] font-bold  leading-[1.8rem] text-[1.7rem] justify-self-start'
							>
								{item.title}
							</div>
						) : (
							<div
								className={` flex flex-row items-center cursor-pointer text-[#212121E5] font-bold  leading-[1.8rem] text-[1.7rem]`}
								key={id}
							>
								{item.title}
							</div>
						)
					)}
				</Card>
				{items.map((item, id) => (
					<Card
						key={id}
						className=' grid grid-cols-5 px-[3rem] py-[1.5rem] gap-[4rem] justify-between items-center text-[1.6rem] h-[8rem] SupportTicketTable-body  my-4'
					>
						<div className=' flex flex-row items-center justify-start'>
							{item?.file_name}
						</div>
						<div>{item?.group_name}</div>
						<div>{item?.username}</div>
						<div>{documentName[item?.type]}</div>
						<div className='flex justify-around'>
							<div className='flex flex-col cursor-pointer'>
								<Send />
							</div>
							<div
								className='flex flex-col justify-center items-center cursor-pointer'
								onClick={() => handleDeleteDocument(item?.id)}
							>
								<Trash />
							</div>

							<div
								className='flex flex-col cursor-pointer'
								onClick={() => handleSelectedDocument(item)}
							>
								<Edit />
							</div>
						</div>
					</Card>
				))}
			</>
		</div>
	);
};
export default DocumentsInfo;

const header = [
	{ title: 'نام فایل' },
	{ title: 'نام تیم' },
	{ title: 'نام فرد' },
	{ title: 'نام مدرک' },
];

const documentName = {
	EndCourse: 'پایان دوره',
	BestTeam: 'تیم برتر',
	Participant: 'گواهی حضور',
};
